import { useFieldContext } from "@/lib/form-context"
import { FormField, FormLabel, FormDescription, FieldInfo } from "@/components/ui/form"
import { PLAYLIST_COLORS } from "@/lib/playlist-colors"
import { cn } from "@/lib/utils"
import { RiCheckLine } from "@remixicon/react"

interface ColorPickerFieldProps {
  label: string
  required?: boolean
  description?: string
}

export function ColorPickerField({
  label,
  required,
  description,
}: ColorPickerFieldProps) {
  const field = useFieldContext<string>()

  return (
    <FormField>
      <FormLabel required={required}>{label}</FormLabel>
      <div className="flex flex-wrap gap-2.5 pt-0.5">
        {Object.entries(PLAYLIST_COLORS).map(([key, { label: colorLabel, value }]) => {
          const isSelected = field.state.value === key
          return (
            <button
              key={key}
              type="button"
              title={colorLabel}
              className={cn(
                "relative flex size-7 items-center justify-center rounded-full transition-all duration-150",
                "hover:scale-110",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
                isSelected
                  ? "scale-110 ring-2 ring-offset-2 ring-offset-background"
                  : "opacity-70 hover:opacity-100"
              )}
              style={{
                backgroundColor: value,
                ...(isSelected && { '--tw-ring-color': value } as React.CSSProperties),
                ...(isSelected && { boxShadow: `0 0 8px 1px color-mix(in oklch, ${value} 40%, transparent)` }),
              }}
              onClick={() => {
                field.handleChange(isSelected ? "" : key)
              }}
            >
              {isSelected && (
                <RiCheckLine className="size-3.5 text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]" />
              )}
            </button>
          )
        })}
      </div>
      {description && <FormDescription>{description}</FormDescription>}
      <FieldInfo field={field} />
    </FormField>
  )
}
